import React, { useState } from "react";
import { FONT_COL_CODES, STAGE_COLOR_CODES } from "../../constant/colors";
import {
  AngleArrowIcon,
  CircularEditIcon,
  CloseIcon,
  HistoryIconBlack,
} from "../../assets/images";
import { formateDateWithTime } from "../../utils/commonFunctions";
import { LeadModuleStageHistoryListType } from "../../commonTypes/clientDirectoryTypes";
import { TableLoader } from "../commons";

type AppProps = {
  leadHistory: LeadModuleStageHistoryListType[];
  storeHistoryData: any;
  setShowHistoryModal: React.Dispatch<React.SetStateAction<boolean>>;
  showHistoryModal: boolean;
  fetching: boolean;
};
const LeadModuleStageHistory = ({
  leadHistory,
  storeHistoryData,
  setShowHistoryModal,
  showHistoryModal,
  fetching,
}: AppProps) => {
  const [toggle, setToggle] = useState(false);
  const backColor = (name: string) => {
    const lowerCaseName = name.toLowerCase();

    let backgroundColor;
    let fontColor;

    if (lowerCaseName.startsWith("1")) {
      backgroundColor = STAGE_COLOR_CODES[0];
      fontColor = FONT_COL_CODES[0];
    } else if (
      lowerCaseName.startsWith("2a") ||
      lowerCaseName.startsWith("2b") ||
      lowerCaseName.startsWith("2bii") ||
      lowerCaseName.startsWith("2biii") ||
      lowerCaseName.startsWith("2biv") ||
      lowerCaseName.startsWith("2bv")
    ) {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (
      lowerCaseName.startsWith("2c") ||
      lowerCaseName.startsWith("2d")
    ) {
      backgroundColor = STAGE_COLOR_CODES[2];
      fontColor = FONT_COL_CODES[2];
    } else if (
      lowerCaseName.startsWith("3a") ||
      lowerCaseName.startsWith("3b")
    ) {
      backgroundColor = STAGE_COLOR_CODES[3];
      fontColor = FONT_COL_CODES[3];
    } else if (
      lowerCaseName.startsWith("4a") ||
      lowerCaseName.startsWith("4b") ||
      lowerCaseName.startsWith("5")
    ) {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else if (
      lowerCaseName.startsWith("6a") ||
      lowerCaseName.startsWith("6b") ||
      lowerCaseName.startsWith("6c") ||
      lowerCaseName.startsWith("6d") ||
      lowerCaseName.startsWith("6e")
    ) {
      backgroundColor = STAGE_COLOR_CODES[5];
      fontColor = FONT_COL_CODES[5];
    } else {
      backgroundColor = STAGE_COLOR_CODES[6];
      fontColor = FONT_COL_CODES[6];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };

  const styleColor = (name: string) => {
    const { backgroundColor, fontColor } = backColor(name);

    return {
      marginTop: "20px",
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const blank = () => {
    return {};
  };

  return (
    <>
      <div
        id="close-popup"
        className="pb-2"
        style={{
          height: "90vh",
          top: 60,
          border: "1px solid #bfcbe1",
          position: "fixed",
          right: 41,
          width: "423px",
          zIndex: 20,
          paddingBottom: "5px",
          background: "white",
          borderRadius: "6px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            position: "sticky",
          }}
        >
          <div className="ml-3 mt-3">
            <img src={HistoryIconBlack} alt="history icon" className="mr-2" />
            <span style={{ fontWeight: "600", color: "#262a44" }}>
              Lead Activity
            </span>
          </div>
          <div className="mr-3 mt-3">
            <img
              src={CloseIcon}
              style={{ cursor: "pointer" }}
              alt="close icon"
              onClick={() => setShowHistoryModal(false)}
            />
          </div>
        </div>
        <hr />
        <div className="ml-2" style={{ height: "86%", overflow: "auto" }}>
          {leadHistory &&
            leadHistory?.map((el: any, index: number) => {
              return (
                <div className="pl-3 pr-3">
                  <div>
                    <div className="d-flex">
                      <div>
                        <img src={CircularEditIcon} alt="" />
                        {leadHistory[index + 1] ? (
                          <div
                            style={{
                              width: "2px",
                              background: "rgba(191, 203, 225, 0.6)",
                              margin: "auto",
                              height: "100%",
                            }}
                          ></div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="ml-3">
                        {index !== leadHistory?.length - 1 && (
                          <span style={{ fontWeight: "600", color: "#262a44" }}>
                            {el?.updated_by_user}{" "}
                            <span style={{ color: "gray" }}>
                              {" "}
                              updated lead stage for
                            </span>
                            <span
                              style={{ fontWeight: "600", color: "#262a44" }}
                            >{` ${storeHistoryData?.company_name}(${storeHistoryData?.client_code})`}</span>
                          </span>
                        )}
                        {index === leadHistory?.length - 1 && (
                          <span style={{ fontWeight: "600", color: "#262a44" }}>
                            {
                              leadHistory[leadHistory?.length - 1]
                                ?.updated_by_user
                            }
                            <span style={{ color: "gray" }}>
                              {" "}
                              created lead for
                            </span>
                            <span
                              style={{ fontWeight: "600", color: "#262a44" }}
                            >{` ${storeHistoryData?.company_name}(${storeHistoryData?.client_code})`}</span>
                          </span>
                        )}
                        <div>
                          <span style={{ color: "#6e7491", fontSize: "12px" }}>
                            {formateDateWithTime(el?.updated_at)}
                          </span>
                        </div>
                        <div
                          className={
                            leadHistory[index + 1]?.stage ? "mt-3 mb-3" : "mb-3"
                          }
                        >
                          <div>
                            <span
                              style={
                                leadHistory[index + 1]?.stage
                                  ? styleColor(leadHistory[index + 1]?.stage)
                                  : blank()
                              }
                            >
                              {leadHistory[index + 1]?.stage}
                            </span>
                          </div>
                          <div className="d-flex ml-2">
                            {leadHistory[index + 1]?.stage && (
                              <img src={AngleArrowIcon} alt="" />
                            )}
                            <span
                              style={
                                el?.stage ? styleColor(el?.stage) : blank()
                              }
                            >
                              {el?.stage}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {fetching && <TableLoader Rows={8} ColumnPerRow={2} />}
      </div>
    </>
  );
};

export default LeadModuleStageHistory;
